export default function getFailsTableFields(ctx) {
	return [
		{
			field: "date",
			title: ctx.$t("date"),
			align: "start"
		},
		{
			field: "order_id",
			title: ctx.$t("orderId") + " №",
			align: "center"
		},
		{
			field: "manager",
			title: ctx.$t("manager"),
			align: "center"
		},
		{
			field: "fail_reason",
			title: ctx.$t("reason"),
			align: "center"
		},
		{
			field: "amount",
			title: ctx.$t("sum"),
			align: "center"
		},
		{
			field: "website",
			title: ctx.$t("site"),
			align: "center"
		},
		{
			field: "milestone",
			title: ctx.$t("stage"),
			align: "center"
		},
		{
			field: "milestones_total",
			title: ctx.$t("stagesTotal"),
			align: "center"
		}
	];
}
